import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LayerPermission, Permission, PermissionSubject, PermissionSubjectType } from '../classes';
import { API_URL, AUTH_API_URL } from '../config';

@Injectable()
export class PermissionService {
  constructor(private http: HttpClient) {}

  getProjectPermissions(slug: any): Observable<Permission[]> {
    const url = `${API_URL}/projectpermission/?project__slug=${slug}`;
    return this.http.get<{ objects: any[] }>(url).pipe(
      map(data => data.objects.map(item => new Permission(item))),
      catchError(this.handleError)
    );
  }

  updateProjectPermissions(projectSlug: string, permissionData: any): Observable<Permission[]> {
    const url = `${API_URL}/projectpermission/?project__slug=${projectSlug}`;
    return this.http.patch<{ objects: any[] }>(url, permissionData).pipe(
      map(data => data.objects.map(item => new Permission(item))),
      catchError(this.handleError)
    );
  }

  getUsers(): Observable<PermissionSubject[]> {
    const url = `${AUTH_API_URL}/user/`;
    return this.http.get<{ objects: any[] }>(url).pipe(
      map(data =>
        data.objects.map(user => ({
          name: user.username,
          id: user.id,
          resource_uri: user.resource_uri,
          type: 'user' as PermissionSubjectType
        }))
      ),
      catchError(this.handleError)
    );
  }

  getGroups(): Observable<PermissionSubject[]> {
    const url = `${AUTH_API_URL}/group/`;
    return this.http.get<{ objects: any[] }>(url).pipe(
      map(data => data.objects.map(group => Object.assign(group, { type: 'group' as PermissionSubjectType }))),
      catchError(this.handleError)
    );
  }

  getLayerPermissions(id: number): Observable<LayerPermission[]> {
    const url = `${API_URL}/projectlayerpermission/?project_permission__id=${id}`;
    return this.http.get<{ objects: any[] }>(url).pipe(
      map(data => data.objects.map(item => new LayerPermission(item))),
      catchError(this.handleError)
    );
  }

  updateLayerPermissions(projectSlug: string, data: any): Observable<any> {
    const url = `${API_URL}/projectlayerpermission/?project__slug=${projectSlug}`;
    return this.http.patch(url, data);
  }

  private handleError(ex: any) {
    const msg = 'Reguest error:' + ex;
    console.error(msg);
    return observableThrowError(msg);
  }
}
